<div class="bg-white rounded-lg overflow-hidden flex flex-col">
  <div class="flex items-center p-4 border-b border-gray-200 select-none">
    <h3 class="text-lg font-medium">
      Antwoorden <span class="text-gray-500">({{ totalAnswers() }}/{{ maxAnswers }})</span>
    </h3>

    <div class="ml-auto">
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Antwoord verwijderen"
        [disabled]="!selectedAnswerId() || disableControls()"
        (click)="handleAnswerDelete()"
      >
        <mat-icon>delete</mat-icon>
      </button>
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Antwoord bewerken"
        [disabled]="!selectedAnswerId() || disableControls() || !canEditSelectedAnswer()"
        (click)="handleAnswerEdit()"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Antwoord toevoegen"
        [disabled]="!canAddAnswers() || disableControls()"
        (click)="handleAnswerAdd()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col gap-3 overflow-hidden">
    <div
      class="h-full overflow-x-hidden overflow-y-auto scrollbar-width-thin [scrollbar-gutter:stable]"
      cdkDropList
      [cdkDropListData]="nodes()"
      [cdkDropListDisabled]="disableControls()"
      (cdkDropListDropped)="handleAnswerDropped($event)"
    >
      <cdk-accordion #accordion="cdkAccordion">
        @for (answer of nodes(); track answer._id) {
          <app-answer-list-item
            [data]="answer"
            [index]="$index + 1"
            [draggable]="!disableControls()"
            [selected]="selectedAnswerId() === answer._id"
            [clientId]="clientId()"
            [totalAnswers]="totalAnswers()"
            (selectionChange)="selectedAnswerId.set(answer._id)"
          />
        } @empty {
          @if (!selectedQuestionId()) {
            <div class="p-4 text-sm text-gray-500">Selecteer een spraakbericht om de antwoorden te bekijken.</div>
          } @else {
            <div class="p-4 text-sm text-gray-500">Je hebt nog geen antwoorden.</div>
          }
        }
      </cdk-accordion>
    </div>
  </div>
</div>
